// extracted by mini-css-extract-plugin
export default {"expandTriangleIcon":"SubIssuesSummaryToken-module__expandTriangleIcon__wqvZWOa","SubIssuesSummaryToken":"SubIssuesSummaryToken-module__SubIssuesSummaryToken__bLlcGFR"};